var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type, view } from '@colyseus/schema';
import { Role } from '../roles.js';
import { VIEW_TAGS } from '../view-tags.js';
export class Player extends Schema {
    constructor() {
        super(...arguments);
        this.id = '';
        this.sessionId = '';
        this.name = '';
        this.avatarUrl = '';
        this.alive = true;
        this.connected = true;
        this.isHost = false;
        this.clue = '';
        this.hasSubmittedClue = false;
        this.turnOrder = 0;
        this.role = Role.Villager;
        this.secretWord = '';
        this.secretWordLength = 0;
        this.revealedRole = '';
    }
}
__decorate([
    type('string')
], Player.prototype, "id", void 0);
__decorate([
    type('string')
], Player.prototype, "sessionId", void 0);
__decorate([
    type('string')
], Player.prototype, "name", void 0);
__decorate([
    type('string')
], Player.prototype, "avatarUrl", void 0);
__decorate([
    type('boolean')
], Player.prototype, "alive", void 0);
__decorate([
    type('boolean')
], Player.prototype, "connected", void 0);
__decorate([
    type('boolean')
], Player.prototype, "isHost", void 0);
__decorate([
    type('string')
], Player.prototype, "clue", void 0);
__decorate([
    type('boolean')
], Player.prototype, "hasSubmittedClue", void 0);
__decorate([
    type('number')
], Player.prototype, "turnOrder", void 0);
__decorate([
    view(VIEW_TAGS.SELF),
    type('string')
], Player.prototype, "role", void 0);
__decorate([
    view(VIEW_TAGS.SELF),
    type('string')
], Player.prototype, "secretWord", void 0);
__decorate([
    view(VIEW_TAGS.SELF),
    type('number')
], Player.prototype, "secretWordLength", void 0);
__decorate([
    view(VIEW_TAGS.REVEALED),
    type('string')
], Player.prototype, "revealedRole", void 0);
//# sourceMappingURL=Player.js.map